import { CustomPanelHeaderProps } from "../Interfaces/CustomPanel.interfaces";

export const CustomPanelHeader = ({ title, style }: CustomPanelHeaderProps) => (
  <div style={{ fontSize: 26, fontWeight: 700, paddingLeft: 32, ...style }}>{title}</div>
);
